import { IAdCampaign } from '@/bundles/Ad/interfaces';
import { useAdClient } from '@/bundles/Ad/composables/useAdClient';
import AdClient from '@/bundles/Ad/models/AdClient';
import { AdCampaignStatus } from '@/bundles/Ad/types';
import { CreateAdCampaignDto, EditAdCampaignDto, IChangeCampaignStatusDto, IGetCampaignDto } from '@/bundles/Ad/dto';
import { ref } from '@vue/composition-api';
import { adCampaignService } from '@/bundles/Ad/factory/adCampaignServiceFactory';
import AdCampaign from '@/bundles/Ad/models/AdCampaign';

export function useAdCampaign () {
  const { defaultAdClientData } = useAdClient();

  const defaultCampaignData: IAdCampaign = {
    id: 0,
    created: new Date(),
    updated: new Date(),
    client: new AdClient(defaultAdClientData),
    title: '',
    description: null,
    region: 'us',
    status: AdCampaignStatus.pending,
    active: true,
  };

  const listLoading = ref(false);
  const total = ref(0);
  const campaigns = ref<IAdCampaign[]>([]);
  async function fetch (params: IGetCampaignDto) {
    listLoading.value = true;
    // try/catch is needed coz of finally block
    try {
      const response = await adCampaignService.getList(params);
      campaigns.value = response.data;
      total.value = response.total;
    } catch (error) {
      throw error;
    } finally {
      listLoading.value = false;
    }
  }

  const changeStatusLoading = ref(false);
  async function changeStatus (id: number, payload: IChangeCampaignStatusDto) {
    changeStatusLoading.value = true;
    await adCampaignService.changeStatus(id, payload)
      .finally(() => changeStatusLoading.value = false);
  }

  const adCampaign = ref<IAdCampaign>(new AdCampaign(defaultCampaignData));
  const editLoading = ref(false);
  const createLoading = ref(false);
  const getItemLoading = ref(false);
  async function createCampaign (payload: CreateAdCampaignDto) {
    createLoading.value = true;
    await adCampaignService.createCampaign(payload)
      .finally(() => createLoading.value = false);
  }
  async function editCampaign (id: number, payload: EditAdCampaignDto) {
    editLoading.value = true;
    await adCampaignService.editCampaign(id, payload)
      .finally(() => editLoading.value = false);
  }
  async function getCampaign (id: number) {
    getItemLoading.value = true;
    adCampaign.value = await adCampaignService.getCampaign(id)
      .finally(() => getItemLoading.value = false);
  }

  const statuses = Object.keys(AdCampaignStatus).map((item) => ({  title: item, value: AdCampaignStatus[item as keyof typeof AdCampaignStatus] }));

  return {
    defaultCampaignData,
    listLoading,
    total,
    campaigns,
    changeStatusLoading,
    adCampaign,
    editLoading,
    createLoading,
    getItemLoading,
    statuses,
    getCampaign,
    createCampaign,
    fetch,
    changeStatus,
    editCampaign,
  };
}
